import S3Service from "./s3.service.ts";
import { fetchPartner } from "./partner.service.ts";

const imageCache = new Map<number, string | null>();

const curpCache = new Map<number, string | null>();

const pendingRequests = new Map<number, Promise<string | null>>();

const imageCacheByCurp = new Map<string, string | null>();

const pendingRequestsByCurp = new Map<string, Promise<string | null>>();

/** Precarga CURPs en lote (p. ej. readPartnersByBranch) para evitar GET /partners/:id por fila. */
export const prefetchPartnerCurps = (
  entries: Array<{ partnerId: number; curp: string | null | undefined }>
) => {
  for (const { partnerId, curp } of entries) {
    if (!Number.isFinite(partnerId) || partnerId <= 0) continue;
    if (curpCache.has(partnerId)) continue;
    curpCache.set(partnerId, curp?.trim() ? curp.trim() : null);
  }
};

export const getProfileImage = async (
  partnerId: number
): Promise<string | null> => {
  if (imageCache.has(partnerId)) {
    return imageCache.get(partnerId) || null;
  }

  if (pendingRequests.has(partnerId)) {
    return pendingRequests.get(partnerId)!;
  }

  const promise = (async () => {
    try {
      let curp = curpCache.get(partnerId);
      if (curp === undefined) {
        const partner = await fetchPartner(partnerId);
        curp = partner?.person?.curp || null;
        if (curp) {
          curpCache.set(partnerId, curp);
        } else {
          curpCache.set(partnerId, null);
          imageCache.set(partnerId, null);
          return null;
        }
      }

      if (!curp) {
        imageCache.set(partnerId, null);
        return null;
      }

      try {
        const file = await S3Service.getFile("PERFIL_" + curp);
        const url = file?.url || null;
        imageCache.set(partnerId, url);
        return url;
      } catch (error) {
        imageCache.set(partnerId, null);
        return null;
      }
    } catch (error) {
      imageCache.set(partnerId, null);
      return null;
    } finally {
      pendingRequests.delete(partnerId);
    }
  })();

  pendingRequests.set(partnerId, promise);
  return promise;
};

export const clearProfileImageCache = () => {
  imageCache.clear();
  curpCache.clear();
  pendingRequests.clear();
};

export const invalidateProfileImage = (partnerId: number) => {
  imageCache.delete(partnerId);
  curpCache.delete(partnerId);
  pendingRequests.delete(partnerId);
};

export const getProfileImageByCurp = async (
  curp: string
): Promise<string | null> => {
  if (imageCacheByCurp.has(curp)) {
    return imageCacheByCurp.get(curp) || null;
  }

  if (pendingRequestsByCurp.has(curp)) {
    return pendingRequestsByCurp.get(curp)!;
  }

  const promise = (async () => {
    try {
      const file = await S3Service.getFile("PERFIL_" + curp);
      const url = file?.url || null;
      imageCacheByCurp.set(curp, url);
      return url;
    } catch (error) {
      imageCacheByCurp.set(curp, null);
      return null;
    } finally {
      pendingRequestsByCurp.delete(curp);
    }
  })();

  pendingRequestsByCurp.set(curp, promise);
  return promise;
};

export const clearProfileImageCacheByCurp = () => {
  imageCacheByCurp.clear();
  pendingRequestsByCurp.clear();
};

export const invalidateProfileImageByCurp = (curp: string) => {
  imageCacheByCurp.delete(curp);
  pendingRequestsByCurp.delete(curp);
};
